module.exports = __webpack_public_path__ + "img/speaker-low.05ee6afa.svg";